<template>
  <div>
    <v-card outlined>
      <v-card flat>
        <v-card-title>
          Текущая заявка на рейтинг {{ request.rating.semester.number }} семестр
          {{ request.rating.semester.name }}
        </v-card-title>

        <v-card-text>
          <v-row class="ma-4">
            <v-icon :color="getStatusColor(request.status)">{{
              getStatusIcon(request.status)
            }}</v-icon>
            <span class="text-h6 ml-2">{{
              getStatusName(request.status)
            }}</span>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-select
                v-model="model.type.id"
                :items="activityTypeList"
                label="Направление деятельности"
                item-text="typeName"
                item-value="id"
                :readonly="!enableSave"
              />
            </v-col>
            <v-col cols="2">
              <v-text-field
                type="number"
                v-model="model.points"
                label="Баллы"
                :readonly="!enableSave"
              />
            </v-col>
          </v-row>
          <v-row v-if="enableCommission && existsRequest">
            <v-col cols="3">
              <v-text-field v-model="sum" label="Сумма стипендии" readonly />
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="index"
                label="Итоговый коэффициент"
                readonly
              />
            </v-col>
          </v-row>
          <v-row v-if="enableCommission && existsRequest">
            <v-col cols="5">
              <v-data-table
                dense
                :headers="headers"
                :items="rules"
                item-key="id"
                hide-default-footer
              >
                <template v-slot:item.name="{ item }">
                  {{ ruleName(item) }}
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn v-if="enableSave" text color="primary" @click="update">{{
            saveButtonName
          }}</v-btn>
          <v-btn
            v-if="enableSendToWait"
            text
            color="primary"
            @click="updateTo('wait')"
            >Отправить на утверждение</v-btn
          >
          <v-btn
            v-if="enableCommission && existsRequest"
            text
            color="teal darken-2"
            @click="updateTo('accept')"
            >Утвердить</v-btn
          >
          <v-btn
            v-if="enableCommission && existsRequest"
            text
            color="orange darken-4"
            @click="updateTo('reject')"
            >Отклонить</v-btn
          >
          <deleting-dialog
            textButton="Удалить"
            title="Удаление заявки"
            message=" Удалить заявку на рейтинговую стипендию?"
            v-if="enableSendToWait || (enableCommission && existsRequest)"
            @delete-request="deleteRequest"
          />
        </v-card-actions>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import {
  getStatusName,
  getStatusColor,
  getStatusIcon
} from "../../../constants/status.constants";

import {
  createRatingRequest,
  updateRatingRequest,
  deleteRatingRequest,
  infoRatingRequest
} from "../../../services/rating.service";
import { session } from "@/services/session.service";
import DeletingDialog from "../../DeletingDialog.vue";

export default {
  name: "RatingRequestInformation",

  props: {
    request: { type: Object, required: true },
    activityTypeList: { type: Array, default: () => [] }
  },

  components: {
    DeletingDialog
  },

  data() {
    return {
      model: {},
      headers: [
        { text: "Тип", value: "name" },
        { text: "Коэффициент", value: "index" }
      ],
      sum: null,
      index: null,
      rules: [],
      rub: Intl.NumberFormat("ru-RU", {
        style: "currency",
        currency: "RUB",
        currencyDisplay: "symbol"
      })
    };
  },

  watch: {
    request: {
      handler(v) {
        this.model = { ...v };
        this.loadInfo();
      },
      immediate: true
    }
  },

  computed: {
    existsRequest() {
      return this.request.id > 0;
    },
    saveButtonName() {
      return this.request.id > 0 ? "Сохранить" : "Назначить стипендию";
    },
    enableSendToWait() {
      return this.request.id > 0 && this.request.status == "init";
    },
    enableCommission() {
      return session.permission.isAllow("elem", "rating_commission");
    },
    enableSave() {
      return (
        this.enableCommission ||
        this.request.id <= 0 ||
        this.request.status == "init"
      );
    }
  },

  mounted() {},

  methods: {
    getStatusName,
    getStatusColor,
    getStatusIcon,

    ruleName(item) {
      if (item.label === "type") {
        return `Деятельность: ${item.data}`;
      }
      if (item.label === "course") {
        return `Правило по курсу, до выпуска: ${item.data.course}`;
      }
      if (item.label === "points") {
        return `Правило по баллам: ${item.data.min}  ≤ X < ${item.data.max}`;
      }
    },

    async loadInfo() {
      if (this.model.id > 0 && this.enableCommission) {
        try {
          let info = await infoRatingRequest(this.model.id);
          this.sum = this.rub.format(info.sum);
          this.index = info.index;
          this.rules = [
            ...[
              {
                label: "type",
                index: info.type.index,
                data: info.type.typeName
              }
            ],
            ...info.rules
          ];
        } catch (e) {
          this.$notify({
            text: e.response ? e.response.data.message : e,
            type: "error"
          });
        }
      }
    },

    async updateTo(toStatus) {
      var status = this.model.status;
      this.model.status = toStatus;
      try {
        await updateRatingRequest(this.request.id, this.model);
      } catch (e) {
        this.model.status = status;
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
      this.$emit("update");
    },

    async update() {
      try {
        if (this.request.id > 0) {
          await updateRatingRequest(this.request.id, this.model);
        } else {
          await createRatingRequest(this.model);
        }
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
      this.$emit("update");
    },

    async deleteRequest() {
      try {
        await deleteRatingRequest(this.request.id);
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
      this.$emit("update");
    }
  }
};
</script>

<style scoped></style>
